import React from 'react';
import cn from 'classnames';
import "./ProductLink.css";
var styles = { "productLink": "db7c79" };
const ProductLink = ({ title, pdpUrl, children, linkClickCallback, hasAriaStatus = false, className, }) => {
    const handleClick = (e) => {
        if (linkClickCallback) {
            linkClickCallback(e);
        }
    };
    const propsSetup = {
        'aria-hidden': hasAriaStatus,
        href: pdpUrl,
        title,
        onClick: handleClick,
        className: cn(className, styles.productLink),
    };
    return React.createElement("a", Object.assign({}, propsSetup), children);
};
export default ProductLink;
//# sourceMappingURL=ProductLink.js.map